/**
 * Runtime RTL Checker - Isolated from React hooks
 * 
 * This module stores the RTL checker function separately to prevent
 * circular imports when i18n/config.ts imports from hooks.
 * 
 * The checker is set by useI18nInitializer after database loads.
 * Before that, consumers should fall back to bootstrap RTL detection.
 */

let runtimeRtlChecker: ((locale: string) => boolean) | null = null;

/**
 * Get the runtime RTL checker if available
 * Returns null before database configs are loaded
 */
export function getRuntimeRtlChecker(): ((locale: string) => boolean) | null {
  return runtimeRtlChecker;
}

/**
 * Set the runtime RTL checker (called by useI18nInitializer)
 * @param checker - Function that checks if a locale is RTL based on database is_rtl column
 */
export function setRuntimeRtlChecker(checker: (locale: string) => boolean): void {
  runtimeRtlChecker = checker;
}
